export enum TipoAtualizacaoEnum {
  APROVAR = 0,
  REJEICAO = 10,
}
